export default __webpack_public_path__ + "static/media/Head_2_Ear_1_C3.40e9e28e.svg";